import { render, staticRenderFns } from "./StructureChamber.vue?vue&type=template&id=ec8144c0&scoped=true&"
import script from "./StructureChamber.vue?vue&type=script&lang=js&"
export * from "./StructureChamber.vue?vue&type=script&lang=js&"
import style0 from "./StructureChamber.vue?vue&type=style&index=0&id=ec8144c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8144c0",
  null
  
)

export default component.exports